import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { toast } from "react-toastify";
import { resetPasswordApi } from "../../api/apiUrlConst";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  user: any;
}

const ResetPasswordModal: React.FC<Props> = ({
  isOpen,
  toggle,
  user
}) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleReset = async () => {
    if (!password) {
      toast.error("Password cannot be empty");
      return;
    }

    try {
      await resetPasswordApi(user.userId, password);
      toast.success("Password reset successfully");
      setPassword("");
      toggle();
    } catch (err: any) {
      toast.error(err?.response?.data || "Error resetting password");
    }
  };

  return (
   <Modal
  isOpen={isOpen}
  toggle={toggle}
  centered
  contentClassName="border-0"
>
  {/* ===== HEADER ===== */}
  <ModalHeader
    toggle={toggle}
    className="border-0"
    style={{
      background: "linear-gradient(90deg,#374151, #093d92)",
      color: "#fff",
      borderTopLeftRadius: "8px",
      borderTopRightRadius: "8px",
    }}
  >
    🔐 Reset Password
  </ModalHeader>

  <ModalBody className="p-4">

    {/* User Info Box */}
    <div
      className="mb-4 p-3"
      style={{
        background: "#dfe9f8",
        borderRadius: "12px",
      }}
    >
      <div className="small text-muted">
        Resetting password for
      </div>
      <div className="fw-bold text-primary">
        {user?.name}
      </div>
    </div>

    {/* Password Field */}
   <FormGroup>
  <Label className="fw-semibold">
    New Password
  </Label>

  <div className="position-relative">

    <Input
      type={showPassword ? "text" : "password"}
      placeholder="Enter new password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      className="rounded-pill shadow-sm pe-5"
    />

    {/* 👁 Toggle Button */}
    <span
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: "absolute",
        top: "50%",
        right: "15px",
        transform: "translateY(-50%)",
        cursor: "pointer",
        fontSize: "18px",
        color: showPassword ? "#dc3545" : "#6c757d",
      }}
    >
      {showPassword ? "🙈" : "👁"}
    </span>

  </div>

  <small className="text-muted">
    Make sure the password is strong and secure.
  </small>
</FormGroup>
  </ModalBody>

  {/* ===== FOOTER ===== */}
  <ModalFooter
    className="border-0"
    style={{
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px",
    }}
  >
    <Button
      color="light"
      onClick={toggle}
      className="rounded-pill px-4"
    >
      Cancel
    </Button>

    <Button
      className="rounded-pill px-4"
      style={{
        background: "linear-gradient(90deg,#374151, #093d92)",
        border: "none",
        fontWeight: 600,
      }}
      onClick={handleReset}
    >
      🔄 Reset Password
    </Button>
  </ModalFooter>
</Modal>
  );
};

export default ResetPasswordModal;